import { StyleSheet, Text, View } from 'react-native';
import moment from 'moment';
import Colors from 'src/core/utils/Colors';
import Constants from 'src/core/utils/Constants';
import Dimens from 'src/core/utils/Dimens';
import Fonts from 'src/core/utils/Fonts';
import Translations from 'src/core/utils/Translations';
import SvgIcon from 'src/presentation/components/atoms/SvgIcon';
import { SvgIconType } from '@thermenresorts/icons';

export function ReservationDate({ arrivalDate, departureDate }: { arrivalDate: string; departureDate?: string }) {
	return (
		<View style={styles.baseView}>
			<SvgIcon name={SvgIconType.suitcaseFilled} size={Dimens.iconSize16} tintColor={Colors.gray350} />
			<Text style={styles.content}>
				{departureDate && departureDate !== arrivalDate
					? `${moment(arrivalDate, Constants.dateFormatServer).format(Constants.dateFormatDayMonthShort)} - ${moment(departureDate, Constants.dateFormatServer).format(Constants.dateFormatDayMonthShort)}`
					: moment(arrivalDate, Constants.dateFormatServer).format(Constants.dateFormatDayMonthLong)}
			</Text>
		</View>
	);
}

export function ReservationTime({ arrivalTime, departureTime }: { arrivalTime: string; departureTime?: string }) {
	return (
		<View style={styles.baseView}>
			<SvgIcon name={SvgIconType.clockFilled} size={Dimens.iconSize16} tintColor={Colors.gray350} />
			<Text style={styles.content}>
				{arrivalTime}
				{departureTime && ` - ${departureTime}`}
			</Text>
		</View>
	);
}

export function ReservationPersons({ personsCount }: { personsCount: number }) {
	return (
		<View style={styles.baseView}>
			<SvgIcon name={SvgIconType.persons} size={Dimens.iconSize16} tintColor={Colors.gray350} />
			<Text style={styles.content}>
				{personsCount} {personsCount === 1 ? Translations.reservationPersonCount : Translations.reservationPersonCounts}
			</Text>
		</View>
	);
}

export function ReservationID({ id }: { id: string | number }) {
	return (
		<View style={styles.baseView}>
			<SvgIcon name={SvgIconType.voucher} size={Dimens.iconSize16} tintColor={Colors.gray350} />
			<Text style={styles.content}>{id}</Text>
		</View>
	);
}

export function ReservationLocation({ location }: { location: string }) {
	return (
		<View style={styles.baseView}>
			<SvgIcon name={SvgIconType.locationFilled} size={Dimens.iconSize16} tintColor={Colors.gray350} />
			<Text style={styles.content}>{location}</Text>
		</View>
	);
}

const styles = StyleSheet.create({
	baseView: {
		flexDirection: 'row',
		alignItems: 'center',
		gap: Dimens.gap8,
	},
	content: {
		fontFamily: Fonts.barlow,
		fontSize: Dimens.fontSize14,
		lineHeight: Dimens.lineHeight21,
		color: Colors.gray900,
	},
});
